// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__tFFqu","noData":"NoData_noData__f5CCf","noDataDescription":"NoData_noDataDescription__CYh4w","noDataImage":"NoData_noDataImage__oFa2d"};